export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40fd05ff996875f4bbd46b8e998c4b17b51337131c&name=revalidateCommunity!'